@if (!!paymentMethods?.length || client.isCms) {
<span class="p2 col-1 va-m inline-block p-r-2 p-r-3-m p-r-3-s">{{ 'Pay with' | translate }}</span>
}

<!-- payment icons -->
@for (method of paymentMethods; track method) {
<payment-icon [method]="method.payment_method_icon"
              [style.fontSize.px]="client.isX || client.isL ? 24 : 20"
              class="m-l-2 m-l-1-m m-l-1-s va-m inline-block"></payment-icon>
}